import { BaseModel } from "sjs-base-model";
import { v4 } from "uuid";

//tag list source data model
export default class TagSourceModel extends BaseModel {
  id = v4();
  created_by = {
    user_id: "",
    user_name: "",
  };
  created_on = "";

  modified_by = "";
  modified_on = "";
  project = {
    project_id: "",
    project_name: "",
  };

  tag_name = "";

  constructor(data1) {
    super();

    this.update(data1);
  }
}
